module.exports = __webpack_public_path__ + "static/background_menu-74aaeeb9757d6af381f302c7800647f5.jpg";